import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { setProfile } from '../../actions/profile';

const PrivateRoute = ({ children }) => {
  const { isAuthenticated, isLoading, user } = useAuth0();
  const dispatch = useDispatch();
const profileDetails = useSelector((state) => state.profile || {});

  useEffect(() => {
    // Only set profile if it hasn't been set already
    const profileIsEmpty = !profileDetails?.email;
    if (isAuthenticated && user && profileIsEmpty) {
      const rawAppMetadata = user['https://thebrassstargroup.com/app_metadata'] || {};
      const rawUserMetadata = user['https://thebrassstargroup.com/user_metadata'] || {};

      const structuredProfile = {
        email: user.email,
        name: user.name,
        nickname: user.nickname,
        picture: user.picture,
        sub: user.sub,
        updated_at: user.updated_at,
       user_metadata: rawUserMetadata,
        app_metadata: rawAppMetadata,
      };

      dispatch(setProfile(structuredProfile));

      try {
        localStorage.setItem('profile', JSON.stringify(structuredProfile));
      } catch (e) {
        console.warn('Failed to store profile in localStorage', e);
      }
    }
  }, [isAuthenticated, user, dispatch, profileDetails]);

  const isProfileReady = isAuthenticated && profileDetails?.email;


  if (isLoading || !isProfileReady) {
    return <div>Loading user profile...</div>;
  }

  if (!isAuthenticated ) {
    console.warn('PrivateRoute - Missing auth or profile');
    return <Navigate to="/login" replace />;
  }

  return children;
};

PrivateRoute.propTypes = {
  children: PropTypes.node.isRequired,
};

export default PrivateRoute;
